/**
 * Google or Meta source class as cart attribute "Kilde", read from the load URL, with Kilde_kampanje and
 * Kilde_annonse ('' unless an ad class; contract: scripts/test-kilde.mjs). No click id.
 * A successful /cart/add(.js), fetch or XHR, causes one POST to /cart/update.js. No storage, no request at load.
 * bjerve-vipps-ekspress.js holds the cart token while window.bjerveKilde.status is 'venter'.
 */
(function () {
  'use strict';
  if (window.bjerveKilde) return;
  var p = new URLSearchParams(window.location.search);
  function har(k) {
    return Boolean(p.get(k));
  }
  function utm(k, v) {
    return (p.get(k) || '').toLowerCase() === v;
  }
  function noen(k, v) {
    return p.getAll(k).some(function (x) { return x.toLowerCase() === v; });
  }
  var klasse = har('gclid') || har('gbraid') || har('wbraid') ? 'google-annonse'
    : noen('utm_source', 'meta') && noen('utm_medium', 'paid_social') ? 'meta-annonse'
    : utm('utm_content', 'sag_organic') || utm('utm_medium', 'product_sync') ? 'google-gratis'
    : har('srsltid') ? 'google-organisk' : null;
  // An ad click also names its campaign and, landing on /products/<handle>, its ad. The allowlists, first
  // character included, keep markup and spreadsheet formulas out of admin and exports. /cart/update.js merges
  // attributes, so every write sends all three keys and '' clears what an earlier landing left.
  var kampanje = p.get('utm_campaign') || '';
  var sti = /^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/products\/([^/]+)$/.exec(window.location.pathname);
  var handle = sti ? sti[1] : '';
  var annonse = klasse === 'google-annonse' || klasse === 'meta-annonse';
  var attr = {
    Kilde: klasse,
    Kilde_kampanje: annonse && /^[A-Za-z0-9_][A-Za-z0-9_.-]{0,79}$/.test(kampanje) ? kampanje : '',
    Kilde_annonse: annonse && /^[a-z0-9][a-z0-9-]{0,199}$/.test(handle) ? handle : '',
  };
  p = null;
  var state = (window.bjerveKilde = { klasse: klasse, status: 'ingen' });
  if (!klasse) return;
  var nativeFetch = window.fetch;

  function isAdd(input) {
    try {
      var url = String((input && input.url) || input);
      return /\/cart\/add(\.js)?$/.test(new URL(url, window.location.href).pathname);
    } catch (e) {
      return false;
    }
  }

  // A network failure, 429 or 5xx is retried once after 1 s; the warning names the status only.
  function send(retry) {
    function fail(status, transient) {
      if (retry && transient) return setTimeout(send, 1000, false);
      state.status = 'feilet';
      console.warn('bjerve-kilde: Kilde ble ikke lagret, status ' + status);
    }
    nativeFetch(((window.routes && window.routes.cart_update_url) || '/cart/update') + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attr }),
    }).then(
      function (r) {
        if (r.ok) state.status = 'skrevet';
        else fail(r.status, r.status === 429 || r.status >= 500);
      },
      function () {
        fail('nett', true);
      }
    );
  }

  // One write per page load: the first successful add starts it.
  function added(ok) {
    if (!ok || state.status !== 'ingen') return;
    state.status = 'venter';
    send(true);
  }

  if (typeof nativeFetch === 'function') {
    window.fetch = function (input) {
      var result = nativeFetch.apply(this, arguments);
      if (isAdd(input)) {
        result.then(
          function (r) {
            added(r.ok);
          },
          function () {
            added(false);
          }
        );
      }
      return result;
    };
  }
  var x = XMLHttpRequest.prototype;
  var open = x.open;
  var sendX = x.send;
  x.open = function (method, url) {
    this.bjerveKildeAdd = isAdd(url);
    return open.apply(this, arguments);
  };
  x.send = function () {
    if (this.bjerveKildeAdd) {
      this.addEventListener('loadend', function () {
        added(this.status >= 200 && this.status < 300);
      });
    }
    return sendX.apply(this, arguments);
  };
})();
